module.exports = __webpack_public_path__ + "static/assets/010a9b5b7507e4bf355a05ca1d4a9f1b.svg";